export enum StockStatus {
  DUE_IN = "due in",
  AVAILABLE = "available",
  RESERVED = "reserved",
  DAMAGED = "damaged",
  UNAVAILABLE = "unavailable",
}
